/**
 *
 * Url
 *
 * Url constants
 *
 * @author     K. van den Broek <k.vandenbroek@uselab.com>
 * @copyright  Uselab Amsterdam
 *
 */

const HIKING_TRAILS = '/beleef/wandelroutes'

export default {
  HIKING_TRAILS
}
